export default __webpack_public_path__ + "static/media/step2Character.c9281bda.png";